/**
 * @file emailContants.js
 * @description Constants for the Email conversation module within the Agent section.
 *              Includes error message strings, success messages, UI label strings,
 *              user-facing dialog/validation messages, and conversation tab labels.
 *
 * @module emailContants
 *
 * @exports EMAIL_ERRORS             - Error message strings for fetch, assign, send & update ops.
 * @exports EMAIL_SUCCUSS            - Success message strings for assignee update & end conversation.
 * @exports EMAIL_STRING             - UI label strings for dialogs, placeholders, and actions.
 * @exports EMAIL_MESSAGE            - User-facing dialog/validation/empty-state messages.
 * @exports EMAIL_CONVERSATION_TABS  - Tab label strings for the email conversation panel.
 */
export const EMAIL_ERRORS = {
    FETCH_EMAIL_INFO_ERROR: "Error fetching email info:",
    ASSIGN_USER_ERROR: "Error assign user:",
    END_CONVERSATION_ERROR: "Error end conversation:",
    FETCH_USER_INFO_ERROR: "Error user info:",
    UPDATE_ASSIGNEE_ERROR: "Error updating assignee:",
    FETCH_EMAIL_CONVERSATION_BY_ID_ERROR: "Error fetching email conversation by ID:",
    UPDATE_CARA_RESPONSE_CHAT_ERROR: "Error updating Cara response chat:",
    SAVE_EMAIL_RESPONSE_ERROR: "Error saving email response:",
    SEND_EMAIL_RESPONSE_ERROR: "Error sending email response:",
};

export const EMAIL_SUCCUSS = {
    ASSIGNEE_UPDATE: "Assignee updated successfully",
    END_CONVERSATION: "Conversation ended successfully",
};

export const EMAIL_STRING = {
    END_CONVERSATION_DAILOG_HEADER: "Confirm End Conversation",
    ASSIGN_USER_DAILOG_HEADER: "Assign User",
    ASSIGN_ME: "Assign to me",
    ASSIGN_USER: "Assign",
    EMAIL_SEARCH_CUSTOMER_PLACEHOLDER: "Search Customers or Campaigns",
    ASSIGN_TO_PLACEHOLDER: "Assigned To",
    REVIEW_PLACEHOLDER: "Review",
    STATUS_PLACEHOLDER: "Status",
    ASSIGN : "Assign",
    END_CONVERSATION: "End Conversation",
    APPROVE_RESPONSE_LABEL: "Approve Response",
    EDIT_CARA_RESPONSE_HEADER: "Edit Cara Response",
    EDIT_RESPONSE: "Edit Response",
    SUBJECT: "Subject",
    SEND_EMAIL: "Send Email",
    SAVE:  "Save",
};

export const EMAIL_MESSAGE = {
    END_CONVERSATION_DAILOG_MESSAGE: "Are you sure you want to end the conversation with this customer?",
    ASSIGN_USER_VALIDATION_MESSAGE: "Please select a user or check 'Assign to me' option.",
    NO_EMAIL_CONVERSATION: "No user emails found.",
};

export const EMAIL_CONVERSATION_TABS = {
   CONVERSATION: "Conversation",
   PROFILE: "Profile",
   NOTES: "Notes",
   PAYMENT: "Payment",
   HISTORY: "History",
   CHATS: "Chats",
   CALLS: "Calls",
   EMAILS: "Emails",
   TEXT: "Text",

};